import React from "react";
import {
  Home,
  ChefHat,
  Building2,
  MonitorPlay,
  Sofa,
  Hammer,
} from "lucide-react";

function Services() {
  const services = [
    {
      title: "Home Interior Design",
      desc: "Elegant home spaces tailored to your lifestyle.",
      icon: Home,
      image: "homeID.png",
    },
    {
      title: "Modular Kitchen Design",
      desc: "Smart kitchen solutions for better space usage.",
      icon: ChefHat,
      image: "kitchenID.png",
    },
    {
      title: "Office Interior",
      desc: "Productive workspace design for modern businesses.",
      icon: Building2,
      image: "officeID.png",
    },
    {
      title: "3D Visualization",
      desc: "Realistic 3D previews before project execution.",
      icon: MonitorPlay,
      image: "3dID.png",
    },
    {
      title: "Furniture Planning",
      desc: "Custom furniture layouts for perfect space balance.",
      icon: Sofa,
      image: "furnitureID.png",
    },
    {
      title: "Renovation Services",
      desc: "Transform old spaces into modern luxury interiors.",
      icon: Hammer,
      image: "renovationID.png",
    },
  ];

  return (
    <section className="relative py-16 px-6 bg-[#f8f8f8] dark:bg-[#050505] overflow-hidden">
      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-orange-500/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID OVERLAY */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="myheading text-3xl md:text-5xl text-center">
            Our Interior Design{" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              Services
            </span>
          </h2>
          <p className="myparagraph text-gray-500">
            Modern, functional and aesthetic interior solutions.
          </p>
        </div>

        {/* GRID */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="group rounded-2xl overflow-hidden border border-gray-200 dark:border-white/10 bg-white/80 dark:bg-white/5 backdrop-blur-md hover:scale-[1.03] transition duration-300"
              >
                {/* IMAGE */}
                <div className="h-44 overflow-hidden relative">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                  />

                  {/* DARK OVERLAY */}
                  <div className="absolute inset-0 bg-black/20" />
                </div>

                {/* CONTENT */}
                <div className="p-6">
                  {/* ICON */}
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-500/10 text-primary mb-4">
                    <Icon size={24} />
                  </div>

                  {/* TITLE */}
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                    {item.title}
                  </h3>

                  {/* DESC */}
                  <p className="text-gray-600 dark:text-gray-400 text-sm mt-2">
                    {item.desc}
                  </p>

                  {/* BUTTON */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Services;
